import React from "react";

interface SuggestedMethodWrapperProps {
  isSuggested?: boolean;
  title?: string;
  backgroundColor?: string;
  textColor?: string;
  children: React.ReactNode;
}

const SuggestedMethodWrapper: React.FC<SuggestedMethodWrapperProps> = ({
  isSuggested = false,
  title,
  backgroundColor,
  textColor,
  children,
}) => {
  if (!isSuggested) return <>{children}</>;

  return (
    <div
      className="rounded-[20px] px-1 pb-1"
      style={{
        backgroundColor,
        color: textColor,
      }}>
      <p className="text-xs font-semibold text-center py-1">{title}</p>
      {children}
    </div>
  );
};

export default SuggestedMethodWrapper;
